import DOMPurify from 'dompurify'

interface CleanHTMLOptions {
  forbiddenTags?: string[]
}

DOMPurify.addHook('uponSanitizeElement', (node, data) => {
  if (data.tagName === 'a') {
    const parent = node.parentNode

    if (!parent) return

    while (node.firstChild) {
      parent.insertBefore(node.firstChild, node)
    }
    parent.removeChild(node)
  }
})

function removeEmojis(text: string): string {
  return text.replace(
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF]+|[\u2600-\u26FF])/g,
    '',
  )
}

export const getCleanHTML = (text: string, options: CleanHTMLOptions = {}) => {
  const { forbiddenTags = [] } = options

  const noEmojisText = removeEmojis(text)

  return DOMPurify.sanitize(noEmojisText, {
    FORBID_TAGS: forbiddenTags,
  })
}
